"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _scrollbarSize = _interopRequireDefault(require("dom-helpers/util/scrollbarSize"));

var _emotion = require("emotion");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("react-virtualized/dist/commonjs/Grid"));

var actions = _interopRequireWildcard(require("../editorActions"));

var cellStates = _interopRequireWildcard(require("../cellStates"));

var shapes = _interopRequireWildcard(require("../shapes"));

var utils = _interopRequireWildcard(require("../utils"));

var _ColumnHeaderCell = _interopRequireDefault(require("./ColumnHeaderCell"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  overflow: hidden !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  color: ", ";\n  font-size: 11px;\n  font-weight: 600;\n  outline: none;\n  pointer-events: auto;\n  text-transform: uppercase;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var backgroundStyle = (0, _emotion.css)(_templateObject(), colors.platinum, colors.shale);
var noScrollStyle = (0, _emotion.css)(_templateObject2());

var ColumnHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ColumnHeader, _PureComponent);

  function ColumnHeader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ColumnHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ColumnHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      drag: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "gridRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rerenderKey", (0, _memoizeOne.default)(function () {
      return {};
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStyle", (0, _memoizeOne.default)(function (width) {
      return {
        width: width - (0, _scrollbarSize.default)()
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragStart", function (columnIndex) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          rowCount = _this$props.rowCount;
      var selection = {
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: rowCount,
        activeX: columnIndex,
        activeY: 0
      };
      utils.emptyUserSelection();
      dispatch(actions.jumpSelection(selection));
      document.addEventListener('mouseleave', _this.onDragEnd);
      document.addEventListener('mouseup', _this.onDragEnd);

      _this.setState({
        drag: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragMove", function (columnIndex) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          selection = _this$props2.selection;
      var drag = _this.state.drag;

      if (!drag || !selection) {
        return;
      }

      var left = Math.min(selection.activeX, columnIndex);
      var right = Math.max(selection.activeX, columnIndex) + 1;
      var newSelection = (0, _objectSpread2.default)({}, selection, {
        left: left,
        right: right
      });
      dispatch(actions.jumpSelection(newSelection));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragEnd", function () {
      document.removeEventListener('mouseleave', _this.onDragEnd);
      document.removeEventListener('mouseup', _this.onDragEnd);

      _this.setState({
        drag: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "recomputeGridSize", function (columnIndex, rowIndex) {
      _this.gridRef.current.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderColumn", function (_ref) {
      var key = _ref.key,
          columnIndex = _ref.columnIndex,
          style = _ref.style;
      var _this$props3 = _this.props,
          columns = _this$props3.columns,
          selection = _this$props3.selection,
          onGetColumnWidth = _this$props3.onGetColumnWidth,
          onResizeColumn = _this$props3.onResizeColumn;
      var mode = cellStates.getMode(columnIndex, null, selection, false);
      var width = onGetColumnWidth({
        index: columnIndex
      });
      return columnIndex >= columns.length ? null : _react.default.createElement(_ColumnHeaderCell.default, {
        key: key,
        columns: columns,
        columnIndex: columnIndex,
        mode: mode,
        style: style,
        width: width,
        onDragStart: _this.onDragStart,
        onDragMove: _this.onDragMove,
        onResize: onResizeColumn
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderEmpty", function (_ref2) {
      var key = _ref2.key,
          style = _ref2.style;
      return _react.default.createElement("div", {
        key: key,
        style: style
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ColumnHeader, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          columns = _this$props4.columns,
          rowHeight = _this$props4.rowHeight,
          scrollLeft = _this$props4.scrollLeft,
          selection = _this$props4.selection,
          width = _this$props4.width,
          onGetColumnWidth = _this$props4.onGetColumnWidth,
          onGetFirstColumnWidth = _this$props4.onGetFirstColumnWidth;
      var leftRowWidth = onGetFirstColumnWidth();
      var widthWithoutLeftColumn = width - leftRowWidth;
      return _react.default.createElement(_Grid.default, {
        ref: this.gridRef,
        cellRenderer: this.renderColumn,
        className: (0, _emotion.cx)(backgroundStyle, noScrollStyle),
        columnCount: columns.length,
        columnWidth: onGetColumnWidth,
        height: rowHeight,
        rerenderKey: this.rerenderKey(columns, selection),
        rowCount: 1,
        rowHeight: rowHeight,
        scrollLeft: scrollLeft,
        style: this.getStyle(widthWithoutLeftColumn),
        tabIndex: null,
        width: widthWithoutLeftColumn
      });
    }
  }]);
  return ColumnHeader;
}(_react.PureComponent);

exports.default = ColumnHeader;
(0, _defineProperty2.default)(ColumnHeader, "propTypes", {
  columns: _propTypes.default.arrayOf(shapes.column).isRequired,
  dispatch: _propTypes.default.func.isRequired,
  rowHeight: _propTypes.default.number.isRequired,
  rowCount: _propTypes.default.number.isRequired,
  scrollLeft: _propTypes.default.number.isRequired,
  selection: shapes.selection,
  width: _propTypes.default.number.isRequired,
  onGetColumnWidth: _propTypes.default.func.isRequired,
  onGetFirstColumnWidth: _propTypes.default.func.isRequired,
  onResizeColumn: _propTypes.default.func.isRequired
});